import { types } from 'mobx-state-tree'

const RewadsDistribution = types.model('RewardsDistibution', {
  rewardsDistributed: types.optional(types.string, ''),
  distributionCount: types.optional(types.string, ''),
  distributionPercentage: types.optional(types.number, 0),
})

const ProductNew = types.model('productNew', {
  txnAttributeKey1: types.optional(types.string, ''),
  txnAttributeKey2: types.optional(types.string, ''),
  txnAttributeKey3: types.optional(types.string, ''),
  txnAttributeKey4: types.optional(types.string, ''),
  txnAttributeKey5: types.optional(types.string, ''),
  txnAttributeKey6: types.optional(types.string, ''),
  txnAttributeIncluded1: types.optional(types.array(types.string), []),
  txnAttributeExcluded1: types.optional(types.array(types.string), []),
  txnAttributeIncluded2: types.optional(types.array(types.string), []),
  txnAttributeExcluded2: types.optional(types.array(types.string), []),
  txnAttributeIncluded3: types.optional(types.array(types.string), []),
  txnAttributeExcluded3: types.optional(types.array(types.string), []),
  txnAttributeIncluded4: types.optional(types.array(types.string), []),
  txnAttributeExcluded4: types.optional(types.array(types.string), []),
  txnAttributeIncluded5: types.optional(types.array(types.string), []),
  txnAttributeExcluded5: types.optional(types.array(types.string), []),
  txnAttributeIncluded6: types.optional(types.array(types.string), []),
  txnAttributeExcluded6: types.optional(types.array(types.string), []),
})
const Campaign = types.model('Campaign', {
  cId: types.optional(types.string, ''),
  title: types.optional(types.string, ''),
  description: types.optional(types.string, ''),
  startDate: types.optional(types.string, ''),
  endDate: types.optional(types.string, ''),
  startTime: types.optional(types.string, ''),
  endTime: types.optional(types.string, ''),
  startTimestamp: types.optional(types.number, 0),
  endTimestamp: types.optional(types.number, 0),
  type: types.optional(types.string, ''),
  status: types.optional(types.string, ''),
  maxBudget: types.optional(types.number, 0),
  offerMaxCount: types.optional(types.number, 0),
  txnAmountRange: types.optional(types.string, ''),
  paymentModes: types.optional(types.number, 0),
  cardTypes: types.optional(types.string, ''),
  purchaseTypes: types.optional(types.string, ''),
  emiBankName: types.optional(types.array(types.string), []),
  roi: types.optional(types.array(types.string), []),
  emiTenure: types.optional(types.array(types.string), []),
  bins: types.optional(types.array(types.string), []),
  bankIds: types.optional(types.string, ''),
  discount: types.optional(types.string, ''),
  discountType: types.optional(types.string, ''),
  value: types.optional(types.number, 0),
  issueFrequency: types.optional(types.string, ''),
  issueCountPerUser: types.optional(types.number, 0),
  tnc: types.optional(types.string, ''),
  products: types.optional(ProductNew, {}),
  combinedWith: types.optional(types.string, ''),
})

const CampaignData = Campaign.create({
  cId: '1',
  title: '',
  startDate: '',
  endDate: '',
  type: '',
  status: '',
  paymentModes: 0,
  cardTypes: '',
  bankIds: '',
  discount: '',
  discountType: '',
  value: 0,
  issueFrequency: '',
  bins: [],
  issueCountPerUser: 0,
})

export { Campaign, CampaignData }
